import { 
  ACTION, RequestCaseEntityId, ReceiveCaseEntityId, 
  FailRequestCaseEntityId, ReceiveConnectedCasePermissions, 
  RequestConnectedCasePermissions } from './action-types';
import { ActionMap } from 'app/area/case/types';
import { CaseState } from 'app/area/case/types-store';
import { CasePermissions } from 'app/types-shared';

const reduceFromExisting = (state: CaseState, caseId: number, entityId: number, fetching: boolean) => {
  return {
    ...state,
    stateForCaseIds: {
      ...(state.stateForCaseIds || {}),
      [caseId]: {
        ...(state.stateForCaseIds || {})[caseId],
        valid: !!entityId, 
        fetching
      }
    }
  };
};

export const reducers: ActionMap = {

  [ACTION.REQUEST_CASE_ENTITY_ID]: (state: CaseState, action: RequestCaseEntityId): CaseState => {
    return {
      ...reduceFromExisting(state, action.caseId, undefined, true)
    };
  },
  
  [ACTION.RECEIVE_CASE_ENTITY_ID]: (state: CaseState, action: ReceiveCaseEntityId): CaseState => {
    return {
      ...reduceFromExisting(state, action.caseId, action.entityId, false)
    };
  },
  
  [ACTION.FAIL_REQUEST_CASE_ENTITY_ID]: (state: CaseState, action: FailRequestCaseEntityId): CaseState => {
    return {
      ...reduceFromExisting(state, action.caseId, undefined, false)
    };
  },

  [ACTION.REQUEST_CONNECTED_CASE_PERMISSIONS]: (state: CaseState, action: RequestConnectedCasePermissions): CaseState => {
    return {
      ...state,
      stateForCaseIds: {
        ...state.stateForCaseIds,
        ...action.ids.reduce((aggr, id) => ({
          ...aggr,
          [id]: {
            ...(state.stateForCaseIds || {})[id],
            fetchingPermissions: true,
            permissions: undefined
          }
        }), {})
      }
    };
  },

  [ACTION.RECEIVE_CONNECTED_CASE_PERMISSIONS]: (state: CaseState, action: ReceiveConnectedCasePermissions): CaseState => {
    return {
      ...state,
      stateForCaseIds: {
        ...state.stateForCaseIds,
        ...Object.keys(action.permissions).reduce((aggr, id) => ({
          ...aggr,
          [id]: {
            ...(state.stateForCaseIds || {})[id],
            fetchingPermissions: false,
            permissions: action.permissions[id]
          }
        }), {} as { [caseId: string]: { valid: boolean; fetching: boolean; permissions: CasePermissions } })
      }
    };
  }
};
